import { cn } from "@/lib/utils";

export default function IconArrowRight({ className }: { className?: string }) {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='40'
            height='40'
            viewBox='0 0 40 40'
            fill='currentColor'
            className={cn("size-6 mt-1", className)}
        >
            <path
                d='M5.00043 21.6666L29.3104 21.6666L20.4888 30.4883L22.8454 32.845L35.6904 20L22.8454 7.15497L20.4888 9.51164L29.3104 18.3333L5.00043 18.3333L5.00043 21.6666Z'
                fill='inherit'
            />
        </svg>
    );
}
